<template>
  <div class="device-type-rule-bd tb" v-if="funcView.device_type_rule_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" @click="addRule()" v-if="funcView.deviceTypeRule_add">{{ funcView.deviceTypeRule_add }}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 产品型号 -->
        <el-form-item style="float: right">
          <custom-select
            :filterable="true"
            v-model="formSearch.productCode"
            url="productCodeSelectList"
            :props="{ label: 'productName', value: 'productCode' }"
            :placeholder="$t('crm_deviceTypeRule.chan_pin_xing_hao')"
            width="160px"
            @change="onPageChange({ page: 1 })"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange" height="100%">
        <template  slot="action" slot-scope="scope">
          <span></span>
          <el-button v-if="funcView.deviceTypeRule_edit" type="text" size="mini" @click="editRule(scope.row)">{{ funcView.deviceTypeRule_edit }}</el-button>
          <el-button v-if="funcView.deviceTypeRule_del" type="text" size="mini" @click="delRule(scope.row)">{{ funcView.deviceTypeRule_del }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis.js';


// const funcView = {
//   deviceTypeRule_add: '新增规则',
//   deviceTypeRule_edit: '编辑',
//   deviceTypeRule_del: '删除'
// };

export default {
  name: 'deviceTypeRule',
  data() {
    return {
      tableCode: 'deviceTypeRule',
      tableList: [],
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        productCode: '',
        pageSize: 50,
        pageNum: 1
      },
      totalRows: null
    };
  },
  methods: {
    getTableList() {
      this.$getJSON(apis.DeviceBizTypePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    addRule() {
      this.clearTagByKeep('device_type_rule_item');
      this.jump('/redirect/offer/deviceTypeRule/add', {
        type: 'add',
        parentPath: '/offer/deviceTypeRule',
      });
    },
    editRule(row) {
      this.clearTagByKeep('device_type_rule_item');
      this.jump('/redirect/offer/deviceTypeRule/edit', {
        type: 'edit',
        parentPath: '/offer/deviceTypeRule',
        productCode: row.productCode
      });
    },
    delRule(row) {
      this.$showConfirm(this.$t('crm_deviceTypeRule.nqdyscsxdgzm')).then(() => {
        this.$postJSON(`${apis.DeviceBizTypeDelete}/${row.ruleId}`).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success')
          });
          this.getTableList();
        });
      });
    }
  },
  mounted() {
    this.getTableColumn();
    this.getFuncView();

    this.getTableList();
  },
  // activated() {
  //   if (this.getJump('refresh')) {
  //     this.getTableList();
  //     this.jump('/offer/deviceTypeRule', {}, true);
  //   }
  // }
};
</script>

<style></style>
